/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { useAction } from '../../../Common/hooks';
import { upDirection, downDirection } from '../../../Common/constants';
import {
  getCredentialsGridSortCriteria,
  selectCredentialsList,
  selectCredentialsListIsLoading,
} from '../../selectors';
import {
  setCredentialsGridSortCriteria,
  fetchAgencyCredentialsList,
  setCredentialFormCreateMode,
  setShowCredentialForm,
} from '../../actions';

const useAgenciesCredentialsGrid = () => {
  const [credentials, setCredentials] = useState([]);
  const [activeRow, setActiveRow] = useState(undefined);
  const { sortByColumn, sortDirection } = useSelector(getCredentialsGridSortCriteria);
  const dispatchGridSortCriteria = useAction(setCredentialsGridSortCriteria);
  const dispatchFetchCredentials = useAction(fetchAgencyCredentialsList);
  const dispatchSetCredentialFormCreateMode = useAction(setCredentialFormCreateMode);
  const dispatchShowCredentialForm = useAction(setShowCredentialForm);
  const isLoading = useSelector(selectCredentialsListIsLoading);
  const credentialList = useSelector(selectCredentialsList);

  const handleCreateCredential = () => {
    dispatchSetCredentialFormCreateMode();
    dispatchShowCredentialForm();
  };

  useEffect(() => {
    dispatchFetchCredentials();
  }, []);

  useEffect(() => {
    setCredentials(credentialList);
  }, [credentialList]);

  const sortRows = () => {
    const rowsCopy = [...credentials];

    if (sortDirection === 'up') {
      rowsCopy.sort((a, b) => {
        if (a[sortByColumn] < b[sortByColumn]) {
          return -1;
        }

        if (a[sortByColumn] > b[sortByColumn]) {
          return 1;
        }

        return 0;
      });
    } else {
      rowsCopy.sort((a, b) => {
        if (a[sortByColumn] < b[sortByColumn]) {
          return 1;
        }

        if (a[sortByColumn] > b[sortByColumn]) {
          return -1;
        }

        return 0;
      });
    }

    setCredentials(rowsCopy);
  };

  useEffect(() => {
    sortRows();
  }, [sortDirection]);

  const handleColumnClick = ({ headerName, direction }) => {
    sortRows();
    dispatchGridSortCriteria({
      sortByColumn: headerName,
      sortDirection: direction === upDirection ? downDirection : upDirection,
    });
  };

  const handleRowClick = () => {
    setActiveRow(undefined);
  };

  return {
    activeRow,
    isLoading,
    credentials,
    handleColumnClick,
    sortByColumn,
    sortDirection,
    handleRowClick,
    handleCreateCredential,
  };
};

export default useAgenciesCredentialsGrid;
